import PhotoGridViewer from './PhotoGridViewer';

export default PhotoGridViewer;
